(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }

            wishlist()
            
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  function wishlistCacheKey() {
    const wishlistConfigEl = document.getElementById('wishlistConfig');
    const customerId = wishlistConfigEl ? wishlistConfigEl.dataset.customerId : null;
    return customerId ? `kiabi_wishlist_${customerId}` : 'kiabi_wishlist_guest';
  }

  function readWishlistCache() {
    try {
      const raw = localStorage.getItem(wishlistCacheKey());
      return raw ? JSON.parse(raw) : [];
    } catch (err) {
      return [];
    }
  }

  function wishlistItemGid(item) {
    return typeof item === 'string' ? item : item.gid;
  }

  function applyWishlistCache() {
    const cached = readWishlistCache().map(wishlistItemGid);

    const pairs = new Map();
    document.querySelectorAll('.wishlist_fav[data-product-id]').forEach((el) => {
      const id = el.dataset.productId;
      if (!pairs.has(id)) pairs.set(id, {});
      pairs.get(id)[el.dataset.action] = el;
    });

    pairs.forEach((pair) => {
      if (!pair.add || !pair.remove) return;
      const gid = `gid://shopify/Product/${pair.add.dataset.productId}`;
      const inWishlist = cached.includes(gid);
      pair.add.style.display = inWishlist ? 'none' : 'block';
      pair.remove.style.display = inWishlist ? 'block' : 'none';
    });
  }

  function writeWishlistCache(wishlist) {
    if (!Array.isArray(wishlist)) return;
    try {
      localStorage.setItem(wishlistCacheKey(), JSON.stringify(wishlist));
    } catch (err) {
      // localStorage indisponible : on ignore silencieusement
    }
  }

  function toggleGuestWishlistCache(element, action) {
    const productId = element.dataset.productId;
    const gid = `gid://shopify/Product/${productId}`;
    const list = readWishlistCache();

    const next = action === 'add'
      ? (list.some((item) => wishlistItemGid(item) === gid)
          ? list
          : [...list, {
              gid,
              title: element.dataset.productTitle || '',
              image: element.dataset.productImage || '',
              url: element.dataset.productUrl || '',
              price: element.dataset.productPrice || ''
            }])
      : list.filter((item) => wishlistItemGid(item) !== gid);

    writeWishlistCache(next);
  }

  // sessionStorage : le compteur repart de 0 à chaque nouvelle session (navigateur/onglet
  // fermé puis rouvert), mais survit à un simple refresh de la page.
  function maybeShowWishlistGuestModal() {
    let count;
    try {
      count = parseInt(sessionStorage.getItem('kiabi_wishlist_guest_modal_count') || '0', 10) + 1;
      sessionStorage.setItem('kiabi_wishlist_guest_modal_count', String(count));
    } catch (err) {
      return; // sessionStorage indisponible : on ne relance pas la popup
    }

    // 1er ajout de la session, puis tous les 4 ajouts (5e, 9e, 13e...)
    if (count % 4 !== 1) return;

    const modal = document.getElementById('wishlistGuestModal');
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('wishlist-guest-modal-open');
  }

  function bindWishlistGuestModalDismiss() {
    const modal = document.getElementById('wishlistGuestModal');
    if (!modal || modal.dataset.bound === 'true') return;
    modal.dataset.bound = 'true';

    modal.querySelectorAll('[data-wishlist-guest-dismiss]').forEach((el) => {
      el.addEventListener('click', () => {
        modal.hidden = true;
        document.body.classList.remove('wishlist-guest-modal-open');
      });
    });
  }

  function wishlist() {
    applyWishlistCache();
    bindWishlistGuestModalDismiss();
    const wishlistButtons = document.querySelectorAll('.wishlist_fav');

              // Boucle sur chacun et ajoute un écouteur de clic
              wishlistButtons.forEach((btn) => {
                btn.addEventListener('click', async (event) => {
                  const element = event.currentTarget;
                
                  // 🔒 Anti-spam : si déjà en cours, on sort
                  if (element.dataset.disabled === "true") return;

                  const parent = element.parentElement; // ou .closest('[data-product-id]') si besoin
                  const other = parent.querySelector(
                    `.wishlist_fav[data-action="${element.dataset.action === 'add' ? 'remove' : 'add'}"]`
                  );

                  // On bloque les clics et donne un petit feedback visuel
                  element.dataset.disabled = "true";
                  element.classList.add('is-loading');

                  if (other) {
                    other.dataset.disabled = "true";
                    other.classList.add('is-loading');
                    element.style.display = "none";
                    other.style.display = "block";
                    other.classList.add('wishlist-pop');
                    other.addEventListener('animationend', () => other.classList.remove('wishlist-pop'), { once: true });
                  }

                  const wishlistConfigEl = document.getElementById('wishlistConfig');
                  const customerId = wishlistConfigEl ? wishlistConfigEl.dataset.customerId : null;

                  if (!customerId) {
                    toggleGuestWishlistCache(element, element.dataset.action);
                    if (element.dataset.action === 'add') maybeShowWishlistGuestModal();
                    element.dataset.disabled = "false";
                    element.classList.remove('is-loading');
                    if (other) {
                      other.dataset.disabled = "false";
                      other.classList.remove('is-loading');
                    }
                    return;
                  }

                  const body = {
                    productId: element.dataset.productId,
                    action: element.dataset.action
                  };
                  const url = wishlistConfigEl.dataset.url

                  try {
                    const r = await fetch(url, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify(body)
                    });

                    const data = await r.json();

                    if (r.status === 200 && Array.isArray(data.wishlist)) {
                      writeWishlistCache(data.wishlist);
                    } else if (r.status !== 200 && other) {
                      other.style.display = "none";
                      element.style.display = "block";
                    }

                  } catch (err) {
                    console.error(err);
                    if (other) {
                      other.style.display = "none";
                      element.style.display = "block";
                    }
                  } finally {
                    // 🔓 Réactive la div (pour éviter un blocage permanent)
                    element.dataset.disabled = "false";
                    element.classList.remove('is-loading');
                    if (other) {
                      other.dataset.disabled = "false";
                      other.classList.remove('is-loading');
                    }
                    if (window.location.pathname.endsWith('/pages/wishlist')) {
                      const gridItem = element.closest('.grid__item');
                      gridItem.remove()
                      const grid = document.getElementById('product-grid');
                      const emptyState = document.getElementById('wishlistEmptyState');
                      if (grid && emptyState && grid.querySelectorAll('.grid__item').length === 0) {
                        emptyState.style.display = '';
                      }
                    }
                  }
                });
              });
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safe-product-recommandations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
